import { render } from "./SquareRoot.vue?vue&type=template&id=78c50ea3"
import script from "./SquareRoot.vue?vue&type=script&lang=js"
export * from "./SquareRoot.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\HKKARABAG\\Desktop\\Hamza\\JavaScript\\11-denklem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__